import React from 'react';
import './App.css'
import "bootstrap/dist/css/bootstrap.min.css"

import WaterGardens from './components/WaterGardens';

function App() {
  return (
    <div className="App">
      <WaterGardens />
    </div>
  );
}

export default App;
